export const GOOGLE_MAPS_URL =
  'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6095.4557683913445!2d44.5057871!3d40.1928689!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abd173fd4d621%3A0x213beef7d45c07c5!2sAmerican%20University%20of%20Armenia!5e0!3m2!1sen!2sam!4v1746214083577!5m2!1sen!2sam'

export const MEASUREMENT_ID = 'G-17HDZZLX0S'
